
import withStringFormValue from "./withStringFormValue";

const StringInput = props => {
  const { passthroughProps, onChange, value } = props;

  return (
    <input
      className="form-control"
      type="text"
      onChange={onChange}
      value={value || ""}
      {...passthroughProps}
    />
  );
};

export default withStringFormValue(StringInput);
